import { HTTP } from '@/services/http'
import HardwareBrandFactory from '../domain/services/HardwareBrandFactory'

const URL = 'api/hardware-brands'

export function fetchAll () {
  return HTTP.get(URL)
    .then(response => response.data.collection.map(hardwareBrand => HardwareBrandFactory.get(hardwareBrand)))
}
